import { customFetch } from '@/utils/fetch'

export const ChatAPI = {
  suggestTitle: async (threadId: string, message: string): Promise<{ title: string }> => {
    const { title } = await customFetch('/chat/threads/suggestTitle', 'POST', {
      threadId,
      message,
    })
    return { title }
  },
}
